import apiFetch from '../apiFetch'

export default function (token, { page, pageSize, orderBy, dossierSubtype, dealerNumber, searchHistorical }) {
  const queryParamsArray = [
    page ? `page=${page}` : null,
    pageSize ? `pageSize=${pageSize}` : null,
    orderBy ? `orderBy=${orderBy}` : null,
    dossierSubtype ? `dossierSubtypeId=${dossierSubtype}` : null,
    dealerNumber ? `dealerNumber=${dealerNumber}` : null,
    searchHistorical ? `searchHistorical=${searchHistorical}` : null
  ]
  const queryParams = queryParamsArray.reduce(
    (result, query, idx) => result + (query ? (result ? `&${query}` : `?${query}`) : '')
    , ''
  )
  return apiFetch({
    endPoint: `DossierFinder/DossiersSimple${queryParams}`,
    method: 'GET',
    body: null,
    token: token
  })
}
